export default __webpack_public_path__ + "static/media/company-plantypes.7113c237.svg";